import _ from 'lodash';

import {
  CLEAR_ALL_ALERTS,
  CLEAR_CUSTOMER_ALERTS,
  CLEAR_DELETE_RESERVATION_ALERT
} from '../actions/alertActions';

const INITIAL_STATE = {};

export default function alertsReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case CLEAR_ALL_ALERTS:
      return {};

    case CLEAR_CUSTOMER_ALERTS:
      return _.omit(state, 'customerUpdated');

    case CLEAR_DELETE_RESERVATION_ALERT:
      return _.omit(state, 'deleteReservationError');

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/alertsReducer.js